import { Types } from "../../constants/index.js";
import SubField from "../builders/SubField.js";
export default SubField({
  objectType: Types.deviceType,
  baseAttrName: 'options',
  baseAttrField: 'options',
  field: 'imagine/systemId',
  creatable: true,
  editable: true,
  getDefaultValue: () => window.Molten?.config?.api?.systemId,
  displayName: 'Imagine System Id',
  valueType: 'string'
});